// Lightweight i18n: English default + Hindi secondary (for Indian-fusion wedding)
import { useSyncExternalStore } from "react";
import { HI } from "./i18n_hi";

const DICT = {
  en: {
    welcome: "welcome",
    home: "Home",
    feed: "Feed",
    requests: "Requests",
    games: "Games",
    more: "More",
    schedule: "Schedule",
    table: "My Table",
    music: "Music",
    help: "Help",
    order: "Order",
    photo_queue: "Photo Queue",
    embroidery: "Embroidery",
    livestream: "Livestream",
    language: "Language",
    leave: "Leave",
    send: "Send",
    step_inside: "Step inside",
    first_name: "First name",
    last_name: "Last name",
    join_queue: "Join photo queue",
    leave_queue: "Leave queue",
    queue_position: "Your position",
    estimated_wait: "Estimated wait",
    minutes: "min",
    submit: "Submit",
    your_orders: "your orders",
    tonight: "tonight",
    up_next: "up next",
    announcements: "announcements",
    signature_cocktails: "signature cocktails tonight",
    // NOT a credential: guest-facing marketing copy. Secret scanners flag the
    // word "password" in the key name via keyword heuristics (false positive).
    no_app_no_password: "No app, no password — just your name.", // pragma: allowlist secret
  },
  hi: {
    welcome: "स्वागत",
    home: "होम",
    feed: "फ़ीड",
    requests: "ऑर्डर",
    games: "गेम्स",
    more: "और",
    schedule: "कार्यक्रम",
    table: "मेरी टेबल",
    music: "संगीत",
    help: "सहायता",
    order: "ऑर्डर",
    photo_queue: "फोटो लाइन",
    embroidery: "कढ़ाई",
    livestream: "लाइव स्ट्रीम",
    language: "भाषा",
    leave: "बाहर",
    send: "भेजें",
    step_inside: "अंदर आइए",
    first_name: "पहला नाम",
    last_name: "अंतिम नाम",
    join_queue: "फोटो लाइन में जुड़ें",
    leave_queue: "लाइन छोड़ें",
    queue_position: "आपका स्थान",
    estimated_wait: "अनुमानित प्रतीक्षा",
    minutes: "मिनट",
    submit: "जमा करें",
    your_orders: "आपके ऑर्डर",
    tonight: "आज रात",
    up_next: "अगला",
    announcements: "घोषणाएँ",
    signature_cocktails: "विशेष कॉकटेल",
    no_app_no_password: "ऐप नहीं, पासवर्ड नहीं — बस आपका नाम।",
  },
};

const LANG_KEY = "venuefy_lang";

export function getLang() {
  return localStorage.getItem(LANG_KEY) || "en";
}
export function setLang(l) {
  localStorage.setItem(LANG_KEY, l);
  window.dispatchEvent(new Event("venuefy-lang-change"));
}
export function t(key) {
  const lang = getLang();
  return DICT[lang]?.[key] || DICT.en[key] || key;
}

/**
 * Phase 5C.2 — string-keyed translation.
 * Usage: T("Send to kitchen") -> Hindi when lang=hi, else the English string.
 * Fallback is ALWAYS the original English string (never a raw key/undefined).
 * Guest-generated content must NEVER be passed through T().
 */
export function T(str) {
  if (str === null || str === undefined) return "";
  if (getLang() !== "hi") return str;
  return HI[str] || str;
}

// --- Reactive subscription so every mounted page updates instantly on switch ---
function subscribe(cb) {
  window.addEventListener("venuefy-lang-change", cb);
  return () => window.removeEventListener("venuefy-lang-change", cb);
}

/** Hook: re-renders the component tree when the language changes. */
export function useI18n() {
  const lang = useSyncExternalStore(subscribe, getLang, () => "en");
  return { lang, t, T };
}

export const LANGS = [
  { id: "en", label: "English" },
  { id: "hi", label: "हिन्दी" },
];
